import { call, put, select } from 'redux-saga/effects';

import logger from '@elab/core/utils/logger';
import { anonymousDefaultAddress } from '@elab/core/utils/constants';
import { actions as checkoutActions } from '@elab/core/store/checkout';
import { actions as uiActions } from '@elab/core/store/ui';
import { actions as cartActions, selectors as cartSelectors } from '@elab/core/store/cart';
import { selectors as userSelectors } from '@elab/core/store/user';
import { setDeliveryAddress } from '@elab/core/store/cart/saga';
import { getUserId } from '@elab/core/utils/user/sagaHelpers';
import * as configSelectors from '@elab/core/store/config/selectors';
import * as storage from '@elab/core/utils/storage';

import { actions as storeLocatorActions, selectors as storeLocatorSelectors } from '.';

export default function* applyDeliveryPost() {
    try {
        const { storeId } = yield select(storeLocatorSelectors.getSelectedStore);
        const pointsOfServices = yield select(storeLocatorSelectors.getStores);
        const { address } = pointsOfServices.find(({ name }) => name === storeId) || {};
        if (!address) return;

        const userId = yield call(getUserId);
        let userData = yield select(
            userId ? userSelectors.getDefaultAddress : cartSelectors.getAnonymousAddress,
        );

        // Use default predefined anonymous data
        const useAnonymousDefaultAddress = yield select(configSelectors.useAnonymousDefaultAddress);
        if (useAnonymousDefaultAddress && !userId && !userData.email) {
            userData = anonymousDefaultAddress;
        }

        const { email, gender, firstName, lastName } = userData;

        yield call(setDeliveryAddress, {
            ...address,
            gender,
            firstName,
            lastName,
            email,
        });

        const deliveryModeId = yield select(cartSelectors.getDeliveryModeCode);
        const deliveryShortAddressInfo = {
            postalCode: address.postalCode,
            street: address.line2,
        };

        yield call(storage.set, storage.key.ppDeliveryAddress, deliveryShortAddressInfo, true);
        yield put(cartActions.loadPostPointDeliveryDate({ code: deliveryModeId }));
        yield put(cartActions.loadCart());
        yield put(checkoutActions.setChangeDeliveryAddress({ status: false }));
    } catch (e) {
        yield call(logger.error, e);
    }

    yield put(storeLocatorActions.setStoresData({}));
    yield put(uiActions.closeDialog());
}
